import { CountryFilter, GenderFilter, Player, RatingFilter, Sorting } from 'types/global'
import { ActionType } from 'typesafe-actions'
import {
  CLEAR_SUGGESTIONS,
  SUGGESTION_REQUESTED,
  SUGGESTION_COMPLETED,
  SUGGESTION_FAILED,
  SET_FILTERS,
  SET_SORTING,
  RESET_FILTERS,
  RESET_SEARCH_RESULTS,
  SEARCH_REQUESTED,
  SEARCH_COMPLETED,
  SEARCH_FAILED,
  SET_SEARCH_QUERY,
} from 'actions/search-actions'

import * as actions from 'actions/search-actions'
import { PostScoreModalId } from 'constants/modals'
import { DEFAULT_TABLE_SORTING } from 'constants/player-search'

type SearchBarAction = ActionType<typeof actions>

export type SearchFilters = {
  gender?: GenderFilter
  ageGroup?: string
  countries?: CountryFilter
  rating?: RatingFilter | null
}

export type State = Readonly<{
  suggestions: {
    [searchBarKey: string]: Player[]
  }
  suggestionsPending: { [key: string]: boolean }
  filters: { [key: string]: SearchFilters }
  sorting: { [key: string]: Sorting | null }
  searchQuery: { [key: string]: string }
  results: { [key: string]: any[] }
  total: { [key: string]: number }
  resultsPending: { [key: string]: boolean }
  pendingQueries: string[]
}>

export const initialState: State = {
  suggestions: {},
  suggestionsPending: {},
  searchQuery: {},
  /* filter initial state for 'player-search bar'. Range and gender will always have a value*/
  filters: {
    'player-search': {},
    'player-search-watchlist': {},
    [PostScoreModalId.ADD_PLAYER]: {},
  },
  sorting: {
    'player-search': DEFAULT_TABLE_SORTING,
    'player-search-watchlist': DEFAULT_TABLE_SORTING,
    [PostScoreModalId.ADD_PLAYER]: DEFAULT_TABLE_SORTING,
  },
  results: {},
  total: {},
  resultsPending: {},
  pendingQueries: [],
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: SearchBarAction): State {
  const id: string = action.payload && action.payload.searchId

  switch (action.type) {
    case SEARCH_REQUESTED:
      state.pendingQueries.unshift(action.payload.queryId)
      return {
        ...state,
        resultsPending: { ...state.resultsPending, [action.payload.searchId]: true },
      }
    case SEARCH_COMPLETED:
      if (state.pendingQueries.includes(action.payload.queryId)) {
        return {
          ...state,
          resultsPending: { ...state.resultsPending, [id]: false },
          total: { ...state.total, [id]: action.payload.total },
          results: {
            ...state.results,
            [id]: [...(state.results[id] || []), ...action.payload.results],
          },
          pendingQueries: state.pendingQueries.filter(qId => qId !== action.payload.queryId),
        }
      }

      return {
        ...state,
      }
    case SEARCH_FAILED:
      if (state.pendingQueries.includes(action.payload.queryId)) {
        return {
          ...state,
          resultsPending: { ...state.resultsPending, [action.payload.searchId]: false },
        }
      }

      return {
        ...state,
      }
    case SET_SEARCH_QUERY:
      return { ...state, searchQuery: { ...state.searchQuery, [id]: action.payload.searchQuery } }
    case SUGGESTION_COMPLETED:
      return {
        ...state,
        suggestions: { ...state.suggestions, [id]: action.payload.suggestions },
        suggestionsPending: { ...state.suggestionsPending, [id]: false },
      }
    case CLEAR_SUGGESTIONS:
      return { ...state, suggestions: { ...state.suggestions, [id]: [] } }
    case SUGGESTION_REQUESTED:
      return {
        ...state,
        suggestionsPending: { ...state.suggestionsPending, [id]: true },
      }
    case SUGGESTION_FAILED:
      return { ...state, suggestionsPending: { ...state.suggestionsPending, [id]: false } }
    case SET_FILTERS: {
      return {
        ...state,
        filters: { ...state.filters, [id]: { ...state.filters[id], ...action.payload.filter } },
      }
    }
    case SET_SORTING: {
      return {
        ...state,
        sorting: { ...state.sorting, [id]: action.payload.sorting },
      }
    }
    case RESET_FILTERS: {
      return { ...state, filters: { ...state.filters, [id]: initialState.filters[id] } }
    }
    case RESET_SEARCH_RESULTS: {
      return {
        ...state,
        total: { ...state.total, [id]: initialState.total[id] },
        results: { ...state.results, [id]: initialState.results[id] },
        pendingQueries: state.pendingQueries.filter(qId => !qId.startsWith(`${id}.`)),
      }
    }
    default:
      return state
  }
}
